import { handleActions } from "redux-actions";
import { DND_DRAG, DND_DROP } from "constants/action-types";

const initialState = {
    dragging: false,
    monitor: null,
};

const activeList = handleActions(
    {
        [DND_DRAG]: (state, { payload }) => Object.assign({}, state, { dragging: true, monitor: payload }),
        [DND_DROP]: (state) => Object.assign({}, state, { dragging: false, monitor: null }),
    },
    initialState
);

export default activeList;
